/*
 *   说明    用H5获取当前用户所在位置
 *   @param  {function}  callback 位置获取成功后的回调函数
 */
export default function getCurLocation(callback) {

    //H5获取用户地理位置
    function getLocation() {
        if (wx.getLocation) {
            wx.getLocation({success: showPosition});
        } else {
            alert("浏览器不支持地理定位。");
        }
    }

    //H5定位出错
    function showError(error) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                //alert("定位失败,用户拒绝请求地理定位");
                break;
            case error.POSITION_UNAVAILABLE:
                //alert("定位失败,位置信息是不可用");
                break;
            case error.TIMEOUT:
                //alert("定位失败,请求获取用户位置超时");
                break;
            case error.UNKNOWN_ERROR:
                //alert("定位失败,定位系统失效");
                break;
        }
    }

    function renderReverse(data) {
        if (typeof callback === 'function')
            callback(data)
    }

    window.renderReverse = renderReverse;

    function showPosition(position) {
        var latlon = position.latitude + ',' + position.longitude;
        var url = "/v2/?ak=1314E3Ad18a68519703e6bcc033540a6&callback=renderReverse&location=" + latlon + "&output=json&pois=0";
        var script = document.createElement('script');
        script.setAttribute('src', url);
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    getLocation();
}


// WEBPACK FOOTER //
// ./src/utils/getCurLoaction.js